import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Megaphone, MessageCircle, Paperclip } from 'lucide-react';
import {
  useWhatsAppCampaignActiveTab,
  useWhatsAppCampaignsBasePath
} from '../../hooks/useWhatsAppCampaignsBasePath';
import { useInboxUnread } from '../../hooks/useInboxUnread';

const TABS = [
  { id: 'campaigns', label: 'Campaigns', icon: Megaphone, segment: '' },
  { id: 'inbox', label: 'Inbox', icon: MessageCircle, segment: 'inbox' },
  { id: 'media', label: 'Media library', icon: Paperclip, segment: 'media' }
];

const WhatsAppCampaignTabs = () => {
  const navigate = useNavigate();
  const basePath = useWhatsAppCampaignsBasePath();
  const activeTab = useWhatsAppCampaignActiveTab();
  const { unread_conversations: inboxUnreadCount = 0 } = useInboxUnread();

  const handleTabClick = (segment) => {
    navigate(segment ? `${basePath}/${segment}` : basePath);
  };

  return (
    <nav
      aria-label="WhatsApp campaign sections"
      className="flex items-end gap-10 px-6 bg-white">
      {TABS.map(({ id, label, icon: Icon, segment }) => {
        const isActive = activeTab === id;
        const showBadge = id === 'inbox' && inboxUnreadCount > 0;

        return (
          <button
            key={id}
            type="button"
            onClick={() => handleTabClick(segment)}
            className={`relative flex items-center gap-2 px-0.5 pt-2.5 pb-3 text-sm font-medium border-b-2 -mb-px transition-colors ${
              isActive
                ? 'text-primary border-primary'
                : 'text-gray-500 border-transparent hover:text-gray-700'
            }`}>
            <Icon className="h-4 w-4 shrink-0" strokeWidth={2} />
            <span className="whitespace-nowrap">{label}</span>
            {showBadge ? (
              <span className="flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold leading-none text-white">
                {inboxUnreadCount > 99 ? '99+' : inboxUnreadCount}
              </span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
};

export default WhatsAppCampaignTabs;
